import * as TYPES from './type';
export default {
  //作业列表
  [TYPES.SK_HOMEWORK_LIST](state, { result }) {
    state.SKHomeWorkList = result.result
  },
  //作业完成学生
  [TYPES.SK_HOMEWORK_STU_COUNT](state, { result }) {
    state.SKHomeWorkStuCount = result.result
  },
  //作业未完成学生
  [TYPES.SK_HOMEWORK_STU_LIST](state, { result }) {
    state.SKHomeWorkStuList = result.result
  },
  //作业详情
  [TYPES.SK_HOMEWORK_DETAILS](state, { result }) {
    state.SKHomeWorkDetails = result.result
  },
  //作业试题列表
  [TYPES.SK_HOMEWORK_TEST_LIST](state, { result }) {
    state.SKHomeWorkTestList = result.result
  },
  //作业学生完成情况
  [TYPES.SK_HOMEWORK_STU_MESSAGE](state, { result }) {
    state.SKHomeWorkStuMessage = result.result
  },
  //作业编辑
  [TYPES.SK_HOMEWORK_EDIT](state, { result }) {
    state.SKHomeWorkEdit = result.result
  },
  //课后测验详情
  [TYPES.SK_HOMETEST_DETAIL](state, { result }) {
    state.SKHomeTestDetail = result.result
  },
}



// WEBPACK FOOTER //
// ./src/store/give-course/homeWork/mutations.js